import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getItemWebStorage } from "../../../features/webStorageSaver";
import { useAppSelector } from "../../../stateManagement/hooks/redux";
import { getBasicObjectTypeLayer } from "../../../widgets/map/mapFeatures/layers";
import MapWidget from "../../../widgets/map/mapWidget/MapWidget";
import { getObjectsOnWMSLayer } from "../../../widgets/map/mapFeatures/mapFunctions/getObjectsOnMapPoint/getObjectsOnMapPoint";
import { mapLayersDict } from "../mapLayersDict";
import ContentHeader from "../../../widgets/contentHeader/ContentHeader";

export function MapRoadWebCameras() {
    const navigate = useNavigate()
    const mapName = "Cameras"
    const [mapTitle, setMapTitle] = useState<string>('');
    const [additionalLayers, setAdditionalLayers] = useState<any>([]);
    const tableUnderMapIsShown = useAppSelector(state => state.contentHeader.tableUnderMapIsShown)
    const { wmsServer, wmsVersion, workspace } = getItemWebStorage('currentConfig')

    useEffect(() => {
        const { mapLayer, caption } = mapLayersDict[mapName] ?? {}
        caption && setMapTitle(`Карта «${caption}»`)
        if (!mapLayer) {
            navigate('/app/error')
        }
        const objectTypeLayer = getBasicObjectTypeLayer(mapLayer, wmsServer, wmsVersion, workspace)
        setAdditionalLayers([objectTypeLayer])
    }, []);

    function applyMapObjectsFind(map: any) {
        const clickFunc = (event: any) => getObjectsOnWMSLayer(event, mapName, additionalLayers[0])
        map?.on("singleclick", clickFunc)
        return {
            off: () => {
                map?.un("singleclick", clickFunc)
            }
        }
    }

    const mapEventHandlers = [
        {
            name: "objectsFind",
            func: applyMapObjectsFind
        }
    ]

    return (
        <>
            <ContentHeader title={mapTitle} />
            <div className="map-widget-with-toast">
                <MapWidget additionalLayers={additionalLayers} mapEventHandlers={mapEventHandlers} mapSizeClass={tableUnderMapIsShown ? 'half-size-map-widget' : null} />
            </div>
        </>
    )
}
